module.exports = __webpack_public_path__ + "img/topLogo.c2d7ed12.svg";